import Form from './email-form';

export const EmailForm = Form;

// Allowing two ways to import, but we could kill one easily.
export default {
  EmailForm: Form,
};
